import { render, staticRenderFns } from "./productFourth.vue?vue&type=template&id=f6e96cb8&scoped=true"
import script from "./productFourth.vue?vue&type=script&lang=js"
export * from "./productFourth.vue?vue&type=script&lang=js"
import style0 from "./productFourth.vue?vue&type=style&index=0&id=f6e96cb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e96cb8",
  null
  
)

export default component.exports